import { clsx } from 'clsx'

import {
  DetailsSidebar,
  useChatContext,
} from '@tribeplatform/react-components/Messaging'
import { useChat } from '@tribeplatform/react-sdk/hooks'

export const ChatDetailsSidebar = () => {
  const { showChatDetails, chatId } = useChatContext()
  const { data: chat } = useChat({
    variables: { id: chatId },
    useQueryOptions: {
      enabled: !!chatId,
    },
  })
  const showSidebar = showChatDetails && !!chat

  return (
    <div
      className={clsx(
        'transition-all duration-300 ease-in-out absolute top-0 right-0 lg:relative h-full bg-surface rounded-e-base',
        !showSidebar && 'w-0 border-none',
        showSidebar &&
          'w-full lg:w-80 shrink-0 lg:border-l lg:border-line-subdued',
      )}
    >
      {showSidebar && (
        <div className="animate-fade-in h-full">
          <DetailsSidebar chatId={chatId} />
        </div>
      )}
    </div>
  )
}
